import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import {
  setCardData,
  setSelectedPaymentMethod,
  setShowSavedPaymentMethods,
  setSurchargeData,
  usePaymentMethods,
} from "../../store/Store";
import Tooltip from "@mui/material/Tooltip";
import { removeSurchargeFromTicketAdjustments } from "../surcharge/api";
import { useTicket } from "../../store/Store";

const PaymentMethodToggle = () => {
  const { t } = useTranslation();

  const { data: ticketData } = useTicket();
  const { showSavedPaymentMethods } = usePaymentMethods();

  const onUseNewCard = useCallback(() => {
    setSurchargeData(null);
    setShowSavedPaymentMethods(false);
    removeSurchargeFromTicketAdjustments(ticketData);
    setSelectedPaymentMethod(null);
    setCardData(null);
  }, [ticketData]);

  return (
    <div className="w-full mb-4 mt-3" data-testid="payment-method-toggle">
      <div className="flex items-stretch bg-gray-100 p-1 rounded-md">
        <button
          onClick={() => setShowSavedPaymentMethods(true)}
          className={`w-full flex-1 py-2 px-4 text-sm font-bold rounded-md transition-colors ${
            showSavedPaymentMethods
              ? "bg-primary text-white"
              : "text-black hover:text-black hover:bg-gray-200"
          }`}
          data-testid="saved-methods-button"
        >
          {t("payment_methods.saved_payment_methods")}
        </button>
        <div className="w-1" />
        <Tooltip
          title={t("payment_methods.single_use")}
          arrow
          placement="top"
          className="flex-1"
        >
          <button
            onClick={onUseNewCard}
            className={`w-full py-2 px-4 text-sm font-bold rounded-md transition-colors ${
              !showSavedPaymentMethods
                ? "bg-primary text-white"
                : "text-black hover:text-gray-700 hover:bg-gray-200"
            }`}
            data-testid="new-card-button"
          >
            {t("payment_methods.one_time_payment")}
          </button>
        </Tooltip>
      </div>
    </div>
  );
};

export default PaymentMethodToggle;
